import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import type { CmsComponent } from "./CmsComponentsApi";
import { getComponent, updateComponent } from "./CmsComponentsApi";

const COMPONENT_NAME = "new-season";
export function useNewSeasonComponent() {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["new-season-component"],
    queryFn: ({ signal }) => getComponent(COMPONENT_NAME, signal),
    retry(_, error) {
      return !(isAxiosError(error) && error instanceof Error && error.response?.status === 404);
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, title, description, buttonLabel, buttonLink }: CmsComponent) =>
      updateComponent({ id, title, description, buttonLabel, buttonLink }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["new-season-component"] }),
  });

  return {
    component: data,
    isLoading,
    updateComponent: updateMutation.mutateAsync,
  };
}
